<script setup lang="ts">
import { useData } from 'vike-vue/useData'
import type { mySelfPageData } from './+data'

const data = useData<mySelfPageData>()
</script>

<template>
  <CommonPagesMyself
    :data="data"
    display-breadcrumb
  />
</template>
